import { gregorianDateTime } from 'Shared/Utils/Extensions/String/StringExtensions';

function TrimJson<T>(obj: Record<any, any | null> | undefined, undefinedNulls: boolean = false) {
  const result: Record<any, any | null> = {};
  if (obj) {
    Object.entries(obj).forEach(([key, val]) => {
      if (undefinedNulls && val == null) result[key] = undefined;

      if (val !== undefined && val !== null) {
        if (typeof val === 'string') result[key] = val.trim();
        else if (val instanceof Date) {
          const date = gregorianDateTime(val);
          result[key] = date;
        } else result[key] = val;
      }
    });
  }

  return result as T;
}

export default TrimJson;
